import { PageType } from "shared/lib/page-type";

export const pathname = "/epaper/tai-po-fire-tragedy-e-paper-collection";

export const page = {
  route(query: QueryParameters) {
    return { pathname, query: { ...query, pageType: PageType.Page } };
  },
};
